/// <reference path="global.d.ts" />
/// <reference path="jquery.d.ts" />
/// <reference path="owlCarousel.d.ts" />
/// <reference path="qtip2.d.ts" />
/// <reference path="refreshResult.d.ts" />

var qtipEvents = {
	show: function() {
		if(window.innerWidth < 641 )
			$('body').addClass('overflow-hidden');
	},
	hide: function() {
		$('body').removeClass('overflow-hidden');
	}
};

$(document).ready(function(){
	$(".owl-carousel").owlCarousel({
		loop: false,
		//responsiveBaseElement: 'body',
		URLhashListener: true,
		mouseDrag: false,
		itemElement: 'li',
		stageElement: 'ol',
		lazyLoad: true,
		nav: true,
		navContainer: false,
		navText: ['<i class="fa fa-2x fa-chevron-left"></i>',
			'<i class="fa fa-2x fa-chevron-right"></i>'],
		responsive: {
			0: {
				items: 1
			},
			640: {
				items: 2
			},
			980: {
				items: 3
			},
			1280: {
				items: 4
			},
			1440: {
				items: 5
			},
			1920: {
				items: 6
			}
		}
	});

	$('body').on('click', '.facilities, .contact-info', function(event) {
		var $button = $(this),
			$target = $button.find('.more'),
			title = translations.facilities;

		if($button.attr('data-hasqtip'))
			return;

		if(!$target.length) {
			$target = $button;
			title = $target.text();
		}

		$button.qtip({
			content: {
				button: 'r',
				title: title,
				text: $button.next().html()},
			position: {
				my: 'top center',
				at: 'bottom center',
				target: $target,
				viewport: $(window)
			},
			show: {
				event: 'click',
				ready: true,
				modal: true
			},
			hide: {
				//event: false,
				fixed: true
			},
			style: {
				classes: 'qtip-facilities qtip-shadow',
				tip: {
					width: 10,
					height: 7,
					mimic: 'center center'
				}
			},
			events: qtipEvents
		});
	});

	$('main').on('click', '.rank', function(event) {
		var $button = $(this);

		if($button.attr('data-hasqtip'))
			return;

		$button.qtip({
			content: {
				button: true,
				title: translations.zooverRank,
				text: $button.find('.zoover-stats').detach()
			},
			position: {
				my: 'top center',
				at: 'bottom center',
				viewport: $(window)
			},
			show: {
				event: 'click',
				ready: true,
				modal: true
			},
			hide: {
				//event: false,
				fixed: true
			},
			style: {
				classes: 'qtip-facilities qtip-shadow',
				tip: {
					width: 10,
					height: 7,
					mimic: 'center center'
				}
			},
			events: qtipEvents
		});
	});

	$('.accordion-navigation .section-header').on('click', function() {
		$(this).parent().toggleClass('accordion-navigation-expanded');
	});

	if(liveroom && !liveroom.ibelink)
		var updater = new Updater();
});

class Notifier {
	private $element:JQuery;
	private offerType:string;
	private timeout: number;
	private qtip: QTip2.Api;

	constructor() {
		this.$element = $(document.createElement('div'));

		this.$element.qtip({
			content: {
				title: false,
				button: true,
				text: function() {
					return '<p>' + translations.newOfferNotify.replace('offer-category', translations.sections[this.offerType]) + '</p>';
				}.bind(this)
			},
			position: {
				my: 'center center',
				at: 'center center',
				target: $(window),
				viewport: $(window)
			},
			show: {
				modal: true
			},
			hide: {
				event: false,
				fixed: true
			},
			style: {
				classes: 'qtip-notification qtip-shadow',
				tip: false
			}
		});

		this.qtip = this.$element.qtip('api');

	}

	public show(offerType:string):void {
		this.offerType = offerType;
		this.qtip.show();

		clearTimeout(this.timeout);
		this.timeout = setTimeout(function() {this.qtip.hide()}.bind(this),5000);
	}

}

class Updater {
	private version:string;
	private offerSelectionURL:string = 'update/selectOffer/';
	private SELECTED_CLASSNAME:string = 'selected';
	private connectionError:boolean = false;
    private updateTimeout: number;
	private updateFunction = this.update.bind(this);
	private $wrapper:JQuery = $('body,html');
	private $offersForm:JQuery = $('#offers-frorm');
	private $totalPrice:JQuery = $('.price-summary');
	private $noOffersAlert:JQuery = $('#no-offers-alert');
	private $mainContent:JQuery = $('#main-content');
	private $footer:JQuery = $('footer');
	private $totalPriceLabel:JQuery = $('.price-summary .value');
	private notifier:Notifier;

	constructor() {
		this.checkOffersQuantity();
		this.version = this.$offersForm.attr('data-basket-rev') || "0";
		this.update();

		$('body').on('change', '.offer-selector', this.handleOfferSelectionChange.bind(this));

		this.notifier = new Notifier;
	}

	private parseOffers(offers: OfferTypes):void {
		var $section:JQuery,
			$carousel:JQuery,
			$listItem:JQuery,
			$item:JQuery,
			changed:boolean = false,
			offerList, offerType:string, offerVal, offerId:string;

		for(offerType in offers) {
			offerList = offers[offerType];

			if(offerList.length)
				continue;

			$carousel = $('#' + offerType);
			$section = $carousel.closest('section');

			for(offerId in offerList) {
				offerVal = offerList[offerId];

				$item = $carousel.find('[data-id="' + offerId + '"]');
				$listItem = $item.closest('.owl-item');

				if ($item.length && !offerVal.length) {
					$carousel.trigger('remove.owl.carousel',$listItem.index());
				} else if($item.length && offerVal.length) {
					// Oferta istnieje - aktualizacja.
					this.verifySectionVisibility($section, $carousel);
					var index = $listItem.index();
					$carousel.trigger('remove.owl.carousel', index);
					$carousel.trigger('add.owl.carousel', [offerVal, index]);
				} else {
					// Oferta nie istnieje - dodanie nowej.
					$carousel.trigger('add.owl.carousel',[offerVal]);
					this.notifier.show(offerType);
					changed = true;
				}


				// Show/hide no offers alert
				this.checkOffersQuantity();
				// Show/hide section
				this.verifySectionVisibility($section, $carousel);
				// adjust items width
				$carousel.trigger('refresh.owl.carousel');
				// trigger img lazy load fix
				$carousel.trigger('initialized.owl.carousel');

				if(changed)
					this.slideToOffer($section, $carousel, offerId);

				this.updateSectionOffersCounter($section);

				// clear changes for next section
				changed = false;
			}


		}
	}

	private slideToOffer($section:JQuery, $carousel:JQuery, offerId: string): void {
		var $item = this.findCarouselItem(offerId);
		if(!$item.length)
			return console.warn('No offer with ID='+offerId);

		this.$wrapper.stop(true, true).animate({
				scrollTop: $section.offset().top
			}, 400);

		$carousel.trigger('to.owl.carousel',[$item.index(), 100]);
		this.blinkItem($item, 1500);
	}

	private blinkItem($item:JQuery, timeout: number):void {
		setTimeout(function() {
			$item.css('opacity', .1);
		}, timeout);
		setTimeout(function() {
			$item.css('opacity', 1);
		}, timeout + 1000);

	}

	private handleOfferSelectionChange(event:Event):void {
		var $target:JQuery = $(event.target),
			$label:JQuery = $target.parent(),
			$offer:JQuery = $target.closest('.offer'),
			url:string = this.offerSelectionURL + $target.val(),
			action:string;

		if($label.attr('disabled'))
			return;

		$offer.toggleClass(this.SELECTED_CLASSNAME);
		($offer.hasClass(this.SELECTED_CLASSNAME)) ? action = 'PZ' : action = 'PN';

		$.ajax({
			url: url + '/' + action
		})
		.done(function(data) {
				if (data.status != 'OK') {
					console.warn('offer selection unsuccessful');
					console.dir(data);
				}
			});

		this.updateSectionSelectionCounter($target.closest('section'));
		this.updateTotalPriceLabel();
	}

	private updateSectionSelectionCounter($section:JQuery):void {
		var selected:number = $section.find('.offer.selected').length,
			$counter:JQuery = $section.find('.section-counter');

		if(selected) {
			$counter.show();
			$section.find('.selected-items-counter').html(selected.toString());
		} else {
			$counter.hide();
		}

	}

	private updateSectionOffersCounter($section:JQuery):void {
		$section.find('.items-counter').html($section.find('.offer').length.toString());
	}

	private verifySectionVisibility($section:JQuery, $carousel:JQuery):boolean {
		var empty:boolean = Boolean(!$section.find('.offer').length),
			visible:boolean = $section.is(':visible');

		if(!empty && !visible) {
			$section.show();
			return true;
		} else if(empty) {
			$section.hide();
			return false;
		}
	}

	private calculateTotalPrice():number {
		var newPrice:number = 0;
		$('.offer.selected').each(function() {
			newPrice += Number($(this).attr('data-price'));
		});
		return newPrice;
	}

	private updateTotalPriceLabel():void {
		var	priceValue = this.calculateTotalPrice(),
			price:string = priceValue.toString(),
			priceArr:string[] = price.split('.');

		if(priceValue == 0 && this.$totalPrice.is(':visible')) {
			this.$totalPrice.hide();
		} else if(!this.$totalPrice.is(':visible')) {
			this.$totalPrice.show();
		}

		if(priceArr.length > 1) {
			this.$totalPriceLabel.html(priceArr[0] + '<sup>' + (priceArr[1]+"0").slice(0,2) + '</sup>');
		} else {
			this.$totalPriceLabel.html(price);
		}
	}

	private checkOffersQuantity():void {
		var offers = $('.offer');

		if(!offers.length) {
			this.$noOffersAlert.show();
			this.$mainContent.hide();
			this.$footer.hide();
		} else {
			this.$footer.show();
			this.$noOffersAlert.hide();
			this.$mainContent.show();
		}
	}

	private update():void {

		$.ajax({
			url: 'update/refresh/' + this.version + '?trackid=' + liveroom.trackid,
			dataType: 'JSON',
			//data: this.$offersForm.serialize()
		}).done( (dataResult: RefreshResultOk) => {

			this.version = dataResult.revision;

			this.parseOffers(dataResult.offers);

			if(dataResult.highlights && dataResult.highlights.length) {
				var $item = this.findCarouselItem(dataResult.highlights),
					$carousel = $item.closest('.owl-carousel'),
					$section = $carousel.closest('section');
				this.slideToOffer($section, $carousel, dataResult.highlights);
			}

			if(this.connectionError) {
				this.connectionError = false;
				console.info('connection restored');
			}
		}).fail( (jqXHR, textStatus, errorThrown) => {
			if(!this.connectionError) {
				this.connectionError = true;
				console.warn('connection error: \n'+textStatus);
			}
		}).always( (jqXHR, textStatus, errorThrown) => {
			this.updateTimeout = setTimeout(this.updateFunction, 1000);
		});
	}

	private findCarouselItem(offerId: string):JQuery {
		return $('.offer[data-id="' + offerId + '"]').parent();
	}

}